var lib_core = require("lib-core");

var NetlistData = function () {
    var self = this;

    this.makeObservableTreeNode();

    this.componentInstances = this.set("componentInstances", true);
    this.nets = this.set("nets", true);
    
    this.componentInstanceNames = new lib_core.NameManager();    // TODO: current namelist should become a shadow, which can be used by the validators and proposal get

    this.buildLogicTerminalNetMap();
    this.onInit("build component list", this.buildNameList);
};
lib_core.mixin(NetlistData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(NetlistData, "NetlistData");

module.exports = NetlistData;

NetlistData.prototype.buildLogicTerminalNetMap = function () {
    var self = this;

    this.logicTerminalNetMap = new lib_core.ObservableMap();

    var addNet = function (net) {
        net.terminals.forEach(function (terminal) {
            self.logicTerminalNetMap.put(terminal, net);
        });
        net.terminals.onAdd({}, function (terminal) {
            self.logicTerminalNetMap.put(terminal, net);
        }, 10);
        net.terminals.onRemove({}, function (terminal) {
            self.logicTerminalNetMap.remove(terminal);
        }, 10);
    };
    var removeNet = function (net) {
        net.terminals.forEach(function (terminal) {
            self.logicTerminalNetMap.remove(terminal, net);
        });
    };

    this.nets.forEach(function (net) {
        addNet(net);
    });
    this.nets.onAdd({}, function (net) {
        addNet(net);
    }, 10);
    this.nets.onRemove({}, function (net) {
        removeNet(net);
    }, 10);
};

NetlistData.prototype.buildNameList = function(){
    var self = this;
    
    var addComponent = function(componentInstance){
        var prefix = componentInstance.template().metaData().prefix();
        if (self.componentInstanceNames.isRegistered(prefix, componentInstance.name())) componentInstance.name(self.componentInstanceNames.getProposal(prefix, componentInstance.name())); // if name of added componentInstance already exist propose a new unique name
        self.componentInstanceNames.register(prefix, componentInstance.name());
        componentInstance.name.onChange("nameManager", function(name, old){
            self.componentInstanceNames.remove(prefix, old);
            self.componentInstanceNames.register(prefix, name);
        });
        componentInstance.name.validator = function(name){
            return name != undefined && !self.componentInstanceNames.isRegistered(prefix, name);
        };
    };
    this.componentInstances.onAdd("nameManager", addComponent);

    var InitialAdd = function(){addComponent(this);};
    this.componentInstances.forEach(function(componentInstance){
        componentInstance.onInit("buildNameList", InitialAdd, 100); // not really efficient: all initial handlers can be removed after executed once
    });

    this.componentInstances.onRemove("nameManager", function(componentInstance){
        var prefix = componentInstance.template().metaData().prefix();
        self.componentInstanceNames.remove(prefix, componentInstance.name());
        componentInstance.name.removeHandlers("nameManager");
        componentInstance.name.validator = null;
    });
};